import { Pipe, PipeTransform } from "@angular/core";
import moment from "moment";

@Pipe({
    name: "customDateFormat",
})
export class CustomDateFormatPipe implements PipeTransform {
    private dateFormat: string = "YYYY-MM-DD HH:mm:ss";
    /** The shapes the API sends (plus ISO 8601, e.g. 2024-05-01T10:30:00Z); anything else is rejected. */
    private apiFormats: moment.MomentFormatSpecification = [
        "YYYY-MM-DD",
        "HH:mm:ss",
        "YYYY-MM-DD HH:mm:ss",
        moment.ISO_8601,
    ];

    constructor() {}

    transform(value: any, format?: string): any {
        // DefaultBlankPipe's "no value" placeholder: show it as is when the pipes are chained
        // (`x | defaultBlank | customDateFormat`), instead of "INVALID DATE".
        if (value === "---") {
            return value;
        }
        const isNotAllowValue = ["Invalid date", "0000-00-00"];
        if (value && value != "" && !isNotAllowValue.includes(value)) {
            const date = moment(value, this.apiFormats, true);
            if (!date.isValid()) {
                return "INVALID DATE";
            }
            if (format && format != "" && format != undefined) {
                return date.format(format);
            }
            return date.format(this.dateFormat);
        }

        return null;
    }
}
